

import { Component, ElementRef, Injector, OnDestroy, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Events, ViewController, Content } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Riordina_3Component } from './riordina_3';
import { RiordinaNew_3Component } from './riordinanew_3';
import { Multipla_1Component } from './multipla_1';
import { Corrispondenza_2Component } from './corrispondenza_2';
import { Ripeti_5Component } from './ripeti_5';
import { CompletaMultipla_6Component } from './completamultipla_6';
import { Valutazione_8Component } from './valutazione_8';

import { Dialogo_10Component } from './dialogo_10';
import { RispostaSingola_11Component } from './rispostasingola_11';
import { RispostaRating_9Component } from './rispostarating_9';
import { RispostaRank_14Component } from './rispostarank_14';
import { CompletaRicostruisci_7Component } from './completaricostruisci_7';
import { ApertaComponent } from './aperta';
import { Mj_Detail } from '../mj_detail/mj_detail';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
import Timer from 'easytimer.js';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { Dashboard } from '../dashboard/dashboard';
import { TranslateService } from '@ngx-translate/core';
import { ApertaRicostruisci_12Component } from './apertaricostruisci_12';
import { Fit_13Component } from './fit_13';
import { GlobalserviceProvider } from '../../providers/globalservice/globalservice';

@Component({
  selector: 'page-msteps',
  templateUrl: 'msteps.html',
})

export class MSteps extends Util implements OnDestroy {
  mq: any;
  mj: any;
  domande: any = [];
  contatoredomande: any = 0;
  allRisposte = {};
  risultati: any = {};
  data_inizio: any;
  dix: any = null;
  timer: any = [];
  tempo_str: string = '';
  show_fine: boolean = false;
  f_generico: boolean = false;
  mytimeout: any = [];
  sfida: any;
  livello: any;
  ris_sfida: any;
  tipitest = ['Test-In', 'Test-out', 'Sfida', 'Follow-up', 'Test-Intermedio'];
  tentativi = 0;
  all_microquest: any;
  settings_mq = { risposteCausali: false, istest: false, superamento: false, possoRifare: false, typewriter: false, mostraGiroBonus: false, abbandona: false, htmlConclusione: null };
  badge_vinti = [];
  arr_store_tempo = {};
  htmlConclusione = '';
  issaved = false;
  rand = Math.random();
  // ce_una_domanda_temporizzata = false;
  @ViewChild(Content, { read: Content }) content: Content;
  @ViewChild('pagetop') pageTop: ElementRef;
  // @ViewChild(IonContent, {static: true}) content: IonCont;
  // @ViewChild('content') contentx: ElementRef;
  //countdown: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    injector: Injector,
    loading: LoadingController,
    public multipla: Multipla_1Component,
    public corrispondenza: Corrispondenza_2Component,
    public riordina: Riordina_3Component,
    public riordinanew: RiordinaNew_3Component,
    public aperta: ApertaComponent,
    public ripeti: Ripeti_5Component,
    public completamultipla: CompletaMultipla_6Component,
    public completaricostruisci: CompletaRicostruisci_7Component,
    public valutazione: Valutazione_8Component,
    public rispostarating: RispostaRating_9Component,
    public rispostarank: RispostaRank_14Component,
    public dialogo: Dialogo_10Component,
    public rispostasingola: RispostaSingola_11Component,
    public events: Events,
    public viewCtrl: ViewController,
    public apertaricostruisci: ApertaRicostruisci_12Component,
    public fit: Fit_13Component,
    public translate: TranslateService,
    public globalservice: GlobalserviceProvider
  ) {


    super(injector, loading);

    // console.log(Date.now());
    // this.get_tempo().then((r)=>{
    //   console.log(r);
    // })
    this.all_microquest = {};
    this.eventsdomande(this.events);

    // alert('costruttore'+this.rand);
  }
  ngOnDestroy(): void {
    // console.log('destroy' + this.rand);
    // this.viewCtrl = null;
    this.remove_all_events();
    // throw new Error('Method not implemented.');
  }
  timeunora;
  ngOnInit(): void {
    // this.ce_una_domanda_temporizzata = false;
    // console.log('NGONINIT -------------------       ');
    window.addEventListener('touchmove', function () { })
    var mq_ = this.navParams.get('mq');
    this.sfida = this.navParams.get('sfida');
    this.livello = this.navParams.get('livello');
    this.issaved = this.navParams.get('issaved');
    // console.log('is_saved',this.issaved);
    this.arr_store_tempo = {};
    var mqId = mq_;
    if (mq_ != undefined && mq_.hasOwnProperty('id')) {
      this.all_microquest = this.navParams.get('mq');
      // console.log(this.all_microquest);
      this.settings_mq.risposteCausali = this.all_microquest.risposteCausali;
      if (this.all_microquest.feedbackImmediatoDomande == null || this.all_microquest.feedbackImmediatoDomande == 0 || this.all_microquest.feedbackImmediatoDomande == '0')
        this.settings_mq.istest = true;
      else
        this.settings_mq.istest = false;
      if (this.all_microquest.feedbackSuperamento == null || this.all_microquest.feedbackSuperamento == 0 || this.all_microquest.feedbackSuperamento == '0')
        this.settings_mq.superamento = false;
      else
        this.settings_mq.superamento = true;
      if (this.all_microquest.possoRifare == null || this.all_microquest.possoRifare == 0 || this.all_microquest.possoRifare == '0')
        this.settings_mq.possoRifare = false;
      else
        this.settings_mq.possoRifare = true;

      if (this.all_microquest.typewriter == null || this.all_microquest.typewriter == 0 || this.all_microquest.typewriter == '0')
        this.settings_mq.typewriter = false;
      else
        this.settings_mq.typewriter = true;

      if (this.all_microquest.mostraGiroBonus == null || this.all_microquest.mostraGiroBonus == 0 || this.all_microquest.mostraGiroBonus == '0')
        this.settings_mq.mostraGiroBonus = false;
      else
        this.settings_mq.mostraGiroBonus = true;

      if (this.all_microquest.abbandona == null || this.all_microquest.abbandona == 0 || this.all_microquest.abbandona == '0')
        this.settings_mq.abbandona = false;
      else
        this.settings_mq.abbandona = true;

      if (this.all_microquest.htmlConclusione == null)
        this.settings_mq.htmlConclusione = null;
      else
        this.settings_mq.htmlConclusione = this.all_microquest.htmlConclusione;

      for (let i = 0; i < this.all_microquest.listTentativi.length; i++) {
        if (this.all_microquest.listTentativi[i] == 'n')
          this.tentativi++;
      }
      //console.log(this.tentativi);
      /*if (this.tipitest.indexOf(this.all_microquest.tipo) != -1) {
        //console.log('è un test !!!!!!!!!!!');
        this.settings_mq.istest = true;
      }
      else
        this.settings_mq.istest = false;
      */

      //console.log(this.settings_mq.istest);
      mqId = mq_.id;
    }
    else {
      // this.timeunora = setTimeout(() => {

      //   // alert('Tempo scaduto');
      //   this.translate.get('sfide.TEMPOSCADUTO').subscribe(v => {
      //     this.showBasicAlert(v, '');
      //   })
      //   this.termina();
      // }, 3600000);
      // 3600000
      //si tratta di una sfida
      this.all_microquest = this.clone(this.navParams.get('sfida'));
      // console.log(this.all_microquest);
      this.settings_mq.risposteCausali = this.all_microquest.microQuest.risposteCausali;
      //this.settings_mq.istest = this.all_microquest.feedbackImmediatoDomande;
      if (this.all_microquest.microQuest.feedbackImmediatoDomande == null || this.all_microquest.microQuest.feedbackImmediatoDomande == 0 || this.all_microquest.microQuest.feedbackImmediatoDomande == '0')
        this.settings_mq.istest = true;
      else
        this.settings_mq.istest = false;

      if (this.all_microquest.microQuest.feedbackSuperamento == null || this.all_microquest.microQuest.feedbackSuperamento == 0 || this.all_microquest.microQuest.feedbackSuperamento == '0')
        this.settings_mq.superamento = false;
      else
        this.settings_mq.superamento = true;
      if (this.all_microquest.microQuest.possoRifare == null || this.all_microquest.microQuest.possoRifare == 0 || this.all_microquest.microQuest.possoRifare == '0')
        this.settings_mq.possoRifare = false;
      else
        this.settings_mq.possoRifare = true;
      // this.settings_mq.istest = true;
      /*if (this.all_microquest.tipo.indexOf(this.tipitest) != -1)
        this.settings_mq.istest = true;
      else
        this.settings_mq.istest = false;
        */

      // console.log(this.settings_mq);
    }

    this.mq = mqId;
    // if(this.mq.tipo.indexOf(this.tipitest) != -1)
    // this.istest  = true;

    this.mj = this.navParams.get('mj');

    //DA COMMENTARE
    // this.storage.set('microquest_' + this.all_microquest.id + '_' + this.gs.userx.id, this.all_microquest);

    //console.log(this.sfida);
    //SE ENTRO CON QUESTIONARIO IN SOSPESO NON DEVE FARE LA REFRESH PAGE ---------------
    if (this.issaved == false || this.issaved == undefined || this.issaved == null) {
      this.get_tempo().then((t) => {
        this.data_inizio = t;
        this.dix = t;
        // console.log('tempo not saved:',this.data_inizio)
        this.arr_store_tempo['start'] = this.data_inizio;
        this.refreshpage(this.mq);
      })


    }

    else {
      this.storage.get('microquest_tempo_' + this.all_microquest.id + '_' + this.gs.userx.id).then((mq_tempo) => {
        // console.log(mq_tempo);
        if (mq_tempo != null && mq_tempo != undefined) {
          this.data_inizio = mq_tempo['start'];
          this.dix = mq_tempo['start'];
          this.arr_store_tempo = mq_tempo;


        }
        else {
          this.arr_store_tempo = {};
          this.get_tempo().then((t) => {
            this.data_inizio = t;
            this.dix = t;

          })
        }
        let domande_aux = this.navParams.get('domande');
        this.domande = domande_aux.MicroStepList;
        // console.log(domande_aux);
        // this.checkdomanda_temporizzata(this.domande).then((ce) => {
        this.allRisposte = this.navParams.get('risposte');
        // console.log(this.allRisposte);
        // this.contatoredomande = Object.keys(this.allRisposte).length;
        this.contatoredomande = Object.keys(this.arr_store_tempo).length - 1;

        // console.log('xxx',this.contatoredomande);
        if (this.contatoredomande == this.domande.length) {
          this.get_tempo().then((t) => {
            this.finequestionario(t);
          })
        }
        // })
        // console.log(this.all_microquest.id);
      })


      // this.contatoredomande =
      // this.domande = [];
      // this.allRisposte = {};
      // this.risultati = {};
      // this.data_inizio = '';
      // this.timer = [];
      // this.tempo_str = '';
      // this.show_fine = false;
      // this.sfida = {};
      // this.livello = '';
      // this.ris_sfida = {};
      // this.contatoredomande = 0;
    }





    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.show_fine = false;


    this.timer = [];

  }

  // checkdomanda_temporizzata(domande) {
  //   return new Promise((resolve, reject) => {
  //     // console.log(domande);
  //     this.ce_una_domanda_temporizzata = false;
  //     for (let i = 0; i < domande.length; i++) {
  //       let d = domande[i];
  //       // console.log(parseInt(d.durataMassima));
  //       if (parseInt(d.durataMassima) != 0 || parseInt(d.durataMinima) != 0) {
  //         // console.log('trueeeeeeeeeeeeeee');
  //         this.ce_una_domanda_temporizzata = true;
  //         resolve(true);
  //         return;
  //       }
  //     }
  //     resolve(false);
  //     // if (this.ce_una_domanda_temporizzata != true) {

  //     //   console.log('falseeeeeeeeeee');
  //     //   resolve(false);
  //     // }
  //   })
  // }

  abbandona() {
    this.domande = [];
    this.allRisposte = {};
    // this.all_microquest = {};
    this.risultati = {};
    this.data_inizio = null;
    this.dix = null;
    this.timer = [];
    this.tempo_str = '';
    this.show_fine = false;
    this.sfida = {};
    this.livello = '';
    this.ris_sfida = {};
    this.contatoredomande = 0;
    // alert(this.ce_una_domanda_temporizzata+'' + this.rand);
    // console.log('falseeeeeeeeeee11');
    // this.ce_una_domanda_temporizzata = false;
    //this.navCtrl.setRoot(Dashboard);
    this.viewCtrl.dismiss('');

    this.events.publish('refreshdashboard');


  }



  abbandona_confirm() {
    let alert = this.alertCtrl.create({
      title: 'Sei sicuro di voler abbandonare?',
      message: '',
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Si, sono sicuro',
          handler: () => {
            // console.log('Buy clicked');
            this.abbandona();
          }
        }
      ],
      cssClass: this.etheme.theme_selected
    });
    alert.present();
  }
  get_tempo() {
    return new Promise((resolve, reject) => {
      this.GetRequest('time', '', false, false).then((tempo: any) => {
        if (tempo.time != undefined && tempo.time != null)
          resolve(tempo.time);
        else
          resolve(Date.now());
      }).catch((x) => {
        resolve(Date.now());
      })
    });
  }
  // ricomincia_da_capo(){
  //   this.domande = [];

  //   this.allRisposte = {};
  //   this.risultati = {};

  //   this.timer = [];
  //   this.tempo_str = '';
  //   this.show_fine = false;
  //   this.sfida = {};
  //   this.livello = '';
  //   this.ris_sfida = {};
  //   this.contatoredomande = 0;
  //   this.navCtrl.push(MSteps, { mq: this.all_microquest, mj: this.mj });
  // }
  updatetimer(domanda) {

    this.mytimeout[domanda.id] = setTimeout(() => {
      if (this.timer[domanda.id] != null && this.timer[domanda.id] != undefined) {
        this.tempo_str = this.timer[domanda.id].getTimeValues().toString();
      }
      this.updatetimer(domanda);

    }, 1000);
  }


  init_tempo(domanda) {

    if (domanda.durataMassima == '0' && domanda.durataMinima == '0') {
      this.showtimer(false);
      //console.log('non mostrare il timer');
      return;
    }
    this.timer[domanda.id] = new Timer();
    //console.log('domanda', this.timer);
    this.updatetimer(domanda);
    if (domanda.durataMinima != undefined && domanda.durataMinima !== '0') {
      this.showtimer(true);
      //console.log('secondi', parseInt(domanda.durataMinima));
      this.timer[domanda.id].start({ precision: 'seconds', startValues: { seconds: 0 }, target: { seconds: parseInt(domanda.durataMinima) } });
      this.timer[domanda.id].addEventListener('targetAchieved', (e) => {
        //console.log('evento-tempo->', e);
        this.stop_tempo(domanda);
        this.events.publish('tempo_' + domanda.id, 'minima');

        //console.log('sono nella minima', domanda.testo);
      });
    }
    else if (domanda.durataMassima != undefined && domanda.durataMassima !== '0') {
      this.showtimer(true);
      this.timer[domanda.id].start({ countdown: true, startValues: { seconds: parseInt(domanda.durataMassima) } });
      this.timer[domanda.id].addEventListener('targetAchieved', (e) => {
        //tempo scaduto!
        //console.log('evento-tempo->', e);
        this.stop_tempo(domanda);
        this.tempo_str = 'Tempo scaduto!';
        this.events.publish('tempo_' + domanda.id, 'massima');
        //console.log('sono nella massima', domanda.testo);
      });

    }
  }

  stop_tempo(domanda) {
    /*if (domanda.durataMassima == '0' && domanda.durataMinima == '0') {
      this.showtimer(false);
      return;
    }*/
    //this.timer.pause();

    //console.log('----------------------------ssssssss----',domanda.id);
    if (this.timer[domanda.id] != null && this.timer[domanda.id] != undefined) {
      //console.log('removeeventlistner', domanda.testo);
      this.timer[domanda.id].stop();

      //this.timer[domanda.id].reset();
      clearTimeout(this.mytimeout[domanda.id]);
      this.timer[domanda.id].removeEventListener('targetAchieved', (e) => {

        //console.log('removeeventlistner');
      });

    }
  }


  refreshpage(mq) {


    this.GetRequest('microStepList', mq).then(data => {
      /*var domande_test = [];
      for(var i=0;i<data['MicroStepList'].length;i++){
        var d = data['MicroStepList'][i]; 
        
        if(d['TipologiaMicroStep_id'] != '8' ) 
          domande_test.push(d);
      }
      domande_test.reverse();
      this.domande = domande_test;*/

      this.domande = data['MicroStepList'];
      // this.checkdomanda_temporizzata(this.domande).then((ce) => {
      // console.log('domanda_temporizzata:', ce);
      // && ce == false
      if (this.mq.temporizzazione == null) {
        this.save_tempo();
        this.storage.set('microquest_risposte_' + this.all_microquest.id + '_' + this.gs.userx.id, this.allRisposte);
        this.storage.set('microquest_' + this.all_microquest.id + '_' + this.gs.userx.id, this.all_microquest);
        this.storage.set('microquest_domande_' + this.mq + '_' + this.gs.userx.id, data);

        let sx = this.mj.id.toString();
        this.storage.get('mq_saved_' + sx + '_' + this.gs.userx.id).then((s: any) => {
          if (s == undefined || s == null || s.lenght == 0) {
            this.storage.set('mq_saved_' + sx + '_' + this.gs.userx.id, [this.mq]);
          }
          else {
            if (s.indexOf(this.mq) == -1) {
              s.push(this.mq);
              this.storage.set('mq_saved_' + sx + '_' + this.gs.userx.id, s);
            }
          }
        })
      }
      // })


    }).catch((e) => {
      console.error(e)
    })
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    /*var countdownNumberEl = document.getElementById('countdown-number');
    var countdown = 3;
    //console.log(countdownNumberEl);
    this.countdown = countdown;

    setTimeout(() => {
      countdown = --countdown <= 0 ? 3 : countdown;
      this.countdown = countdown;
    }, 1000);
    */

  }


  showtimer(flag) {
    var hh = this.contatoredomande;
    var y = document.getElementById("tempo_stringa_" + hh);
    //console.log(y);

    if (y != null && flag == true)
      y.style.display = 'block';
    else if (y != null)
      y.style.display = 'none';
  }
  storeRisposta(domanda, risp, notnext?) {
    /*if (this.timer[domanda.id] != null && this.timer[domanda.id] != undefined) {
      this.timer[domanda.id].reset();
      clearTimeout(this.mytimeout[domanda.id]);
      this.timer[domanda.id].removeEventListener('targetAchieved', (e) => {
        //console.log('removeeventlistner');
      });
      //this.timer[domanda.id] = null;
      //this.timer[domanda.id] = new Timer();
    }*/
    // console.log(domanda);
    this.allRisposte[domanda.id] = risp;
    // && this.ce_una_domanda_temporizzata == false
    if (this.mq.temporizzazione == null)
      this.save_cache();
    var cleanText = '';
    if (domanda.feedbackGenerico != null)
      cleanText = domanda.feedbackGenerico.replace(/<\/?[^>]+(>|$)/g, "").replace(/ /g, '');

    if (notnext == false || notnext == undefined || notnext == null) {
      if (domanda.feedbackGenerico != null && this.settings_mq.istest == false && cleanText.length > 0 && cleanText != ' ') {
        this.f_generico = true;
      }
      else {
        this.next();
      }
    }
    //console.log(this.allRisposte);

  }

  svuota_cache() {
    this.storage.remove('microquest_risposte_' + this.all_microquest.id + '_' + this.gs.userx.id);
    this.storage.remove('microquest_domande_' + this.all_microquest.id + '_' + this.gs.userx.id);
    this.storage.remove('microquest_tempo_' + this.all_microquest.id + '_' + this.gs.userx.id);
    this.storage.remove('microquest_' + this.all_microquest.id + '_' + this.gs.userx.id);
    this.storage.get('mq_saved_' + this.mj.id + '_' + this.gs.userx.id).then((mq_saved) => {
      if (mq_saved.indexOf(this.all_microquest.id) != -1) {
        mq_saved.splice(mq_saved.indexOf(this.all_microquest.id), 1);
        this.storage.set('mq_saved_' + this.mj.id + '_' + this.gs.userx.id, mq_saved);
      }
    })
  }
  save_cache() {
    // console.log(this.all_microquest);
    // console.log(this.allRisposte);
    this.storage.set('microquest_risposte_' + this.all_microquest.id + '_' + this.gs.userx.id, this.allRisposte);

  }

  save_tempo() {
    // console.log(this.all_microquest);
    // console.log(this.allRisposte);
    // console.log('store tempo', this.arr_store_tempo, this.all_microquest.id);
    this.storage.set('microquest_tempo_' + this.all_microquest.id + '_' + this.gs.userx.id, this.arr_store_tempo);

  }

  eventsdomande(event) {
    event.subscribe('aperta', (domanda, risp) => {
      //console.log('aperta', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('riordina', (domanda, risp) => {
      //console.log('riordina', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('corrispondenza', (domanda, risp) => {
      //console.log('corrispondenza', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('rispostasingola', (domanda, risp) => {
      //console.log('rispostasingola', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('completaricostruisci', (domanda, risp) => {
      //console.log('completaricostruisci', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('completamultipla', (domanda, risp) => {
      //console.log('completamultipla', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('dialogo', (domanda, risp) => {
      //console.log('dialogo', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('ripeti', (domanda, risp) => {
      //console.log('ripeti', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('rispostarating', (domanda, risp) => {
      //console.log('rispostarating', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('valutazione', (domanda, risp) => {
      //console.log('valutazione', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('valutazione_first', (domanda, risp) => {
      //console.log('valutazione_first', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp, true);
    });
    event.subscribe('multipla', (domanda, risp) => {
      //console.log('multipla', 'Domanda', domanda, 'risposta', risp);
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('start_tempo', (domanda, s) => {
      // console.log('start_tempo', domanda.id);
      this.store_tempo(domanda.id, true);
      this.init_tempo(domanda);
    });
    event.subscribe('stop_tempo', (domanda, e) => {
      // console.log('stop_tempo', domanda.id);
      this.store_tempo(domanda.id, false);
      // this.stop_tempo(domanda);
    });
    event.subscribe('stop_tempo_parziale', (domanda, e) => {
      // console.log('stop_tempo_parziale', domanda.id);
      this.stop_tempo(domanda);
    });
    event.subscribe('next_feedback_generico', (domanda) => {
      // console.log('tempoxx feedback',domanda);
      this.store_tempo(domanda.id, false);
      this.f_generico = false;
      this.next();
    });
    event.subscribe('rispostarank', (domanda, risp) => {
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('apertaricostruisci', (domanda, risp) => {
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('fit', (domanda, risp) => {
      this.storeRisposta(domanda, risp);
    });
    event.subscribe('get_feedback_fit', (mqid, mstepid, tempi) => {
      this.get_label_fit(mqid, mstepid, tempi);
    });
  }
  get_label_fit(mqid, mstepid, tempi) {
    this.PostRequest('label_feedback', '', { 'mqid': mqid, 'mstepid': mstepid, 'tempi': tempi }, false, false).then((r) => {
      this.globalservice.feedback_fit = r['label'];
    })

  }
  store_tempo(id, isstart) {

    // console.log("STORE_TEMPI", this.arr_store_tempo);
    var time = Date.now();


    // this.get_tempo().then((time) => {
    // console.log('isstartxxx',isstart);
    if (isstart == true) {

      // console.log("HO INIZIATO LA DOMANDA PRE ", id, time, this.arr_store_tempo[id]);

      this.arr_store_tempo[id] = { start: time };

      // console.log("HO INIZIATO LA DOMANDA", id, time, this.arr_store_tempo[id]);

    }
    else {
      // this.arr_store_tempo = JSON.parse(JSON.stringify(this.arr_store_tempo));
      // console.log(this.arr_store_tempo.id);
      // console.log(id);

      // console.log("HO TERMINATO LA DOMANDA PRE", id, time, this.arr_store_tempo[id]);

      var obj = Object.assign(this.arr_store_tempo[id], { end: time });
      this.arr_store_tempo[id] = obj;

      // console.log("HO TERMINATO LA DOMANDA", id, time, this.arr_store_tempo[id]);

      // alert(this.ce_una_domanda_temporizzata+'' + this.rand);
      // console.log(this.all_microquest.id);
      // && this.ce_una_domanda_temporizzata == false
      // console.log(this.mq.temporizzazione);
      if (this.mq.temporizzazione == null) {
        this.save_tempo();
      }
    }

    // })
  }

  // ionViewDidLeave() {
  remove_all_events() {
    this.events.unsubscribe('aperta');
    this.events.unsubscribe('riordina');
    this.events.unsubscribe('corrispondenza');
    this.events.unsubscribe('rispostasingola');
    this.events.unsubscribe('completaricostruisci');
    this.events.unsubscribe('completamultipla');
    this.events.unsubscribe('dialogo');
    this.events.unsubscribe('ripeti');
    this.events.unsubscribe('rispostarating');
    this.events.unsubscribe('rispostarank');
    this.events.unsubscribe('valutazione');
    this.events.unsubscribe('valutazione_first');
    this.events.unsubscribe('multipla');
    this.events.unsubscribe('start_tempo');
    this.events.unsubscribe('stop_tempo');
    this.events.unsubscribe('stop_tempo_parziale');
    this.events.unsubscribe('apertaricostruisci');
    this.events.unsubscribe('next_feedback_generico');
    this.events.unsubscribe('fit');
    this.events.unsubscribe('get_feedback_fit');

    for (let d of this.domande) {
      //console.log('cancello gli eventi'+d.id);
      this.events.unsubscribe('tempo_' + d.id);
    }
    // this.arr_store_tempo = {};
  }

  next() {
    //console.log('asd');
    // let scrollContent = document.getElementById("contentstep");
    // let scrollContent = document.getElementsByClassName("scroll-content");
    // console.log(scrollContent); 
    // scrollContent.scrollTop;
    // console.log(this.pageTop.nativeElement);
    // setTimeout(() => {
    //   // this.pageTop.scrollTo(0, 0);
    //   if (this.pageTop != null)
    //     this.pageTop.nativeElement.scrollTop()
    // }, 1000);

    // if(this.content != null)
    //   this.content.scrollToTop();
    // console.log(this.content.getNativeElement());
    setTimeout(() => {
      if (this.content.getNativeElement() != undefined && this.content != null) {
        try {
          this.content.scrollToTop()
        } catch (error) {

          // console.error('scroll error');
        }

      }
      //  this.content.scrollToTop
      // this.pageTop.nativeElement.scrollIntoView({behavior: 'smooth'}); 
    }, 200);


    this.contatoredomande = this.contatoredomande + 1;
    if (this.contatoredomande == this.domande.length) {

      this.get_tempo().then((t) => {
        this.finequestionario(t);
      })

    }


  }



  finequestionario(tempofine) {
    let di = this.data_inizio;
    if (di == undefined || di == null || di == '') {
      di = this.dix;
    }
    this.remove_all_events();
    let risposte = [];
    let arr_objid = [];
    var parametri = {};

    //console.log(this.arr_store_tempo);
    //console.log(this.allRisposte);
    for (let id_domanda in this.allRisposte) {
      let arr_objid = [];
      for (let i = 0; i < this.allRisposte[id_domanda].length; i++) {
        arr_objid.push({ id: this.allRisposte[id_domanda][i] });
      }
      var s_d = 0;
      var e_d = 0;
      if (this.arr_store_tempo[id_domanda] != undefined) {
        s_d = this.arr_store_tempo[id_domanda]['start'];
        e_d = this.arr_store_tempo[id_domanda]['end'];
      }
      risposte.push({ id: id_domanda, RispostaMicroStepList: arr_objid, start: s_d, end: e_d });
    }

    if (this.sfida != undefined && this.livello != undefined) //sfida random
      parametri = { id: this.mq, MicroStepList: risposte, tempoinizio: di, tempofine: tempofine, sid: this.sfida.id, livello: this.livello };
    else if (this.sfida != undefined) //sfida contro usename
      parametri = { id: this.mq, MicroStepList: risposte, tempoinizio: di, tempofine: tempofine, sid: this.sfida.id };
    else  //questionario semplice
      parametri = { id: this.mq, MicroStepList: risposte, tempoinizio: di, tempofine: tempofine };
    this.PostRequest('risultati', this.mq, parametri, true, true).then((res) => {
      this.htmlConclusione = res['microquest']['htmlConclusione'];
      this.risultati = res['RisultatoMicroQuest'];
      this.badge_vinti = res['badgeList'];
      if (res.hasOwnProperty('sfida'))
        this.ris_sfida = res['sfida'];
      // && this.ce_una_domanda_temporizzata == false
      if (this.mq.temporizzazione == null)
        this.svuota_cache();
      // this.svuota_cachex(this.mj.id,this.mq.id);
      this.show_fine = true;

    }).catch((e) => {
      //this.showBasicAlert('Errore', e);

      this.termina();
      console.error(e);
    })
  }
  termina(p?) {
    //this.navCtrl.push(Mj_Detail, { mj: this.mj });
    //azzerare tutte le strutture
    // this.all_microquest = {};

    this.domande = [];
    this.allRisposte = {};
    this.risultati = {};
    this.data_inizio = null;
    this.dix = null;
    this.timer = [];
    this.tempo_str = '';
    this.show_fine = false;
    this.sfida = {};
    this.livello = '';
    this.ris_sfida = {};
    this.contatoredomande = 0;
    // alert(this.ce_una_domanda_temporizzata+'' + this.rand);
    // console.log('falseeeeeeeeeee12');
    // this.ce_una_domanda_temporizzata = false;
    //this.navCtrl.setRoot(Dashboard);
    if (p == 'ricomincia') {
      // this.navCtrl.setRoot(this.navCtrl.getActive().component); 
      // this.navCtrl.push(MSteps, { mq: this.all_microquest, mj: this.mj });
      this.viewCtrl.dismiss('ricomincia');
    }

    else {
      this.viewCtrl.dismiss('');
      this.events.publish('refreshdashboard');
      // this.navCtrl.pop();
    }

  }
  //https://albert-gonzalez.github.io/easytimer.js/#libraryLoadExample


  cancella_e_termina() {
    this.svuota_cache();
    // this.svuota_cachex(this.mj.id,this.mq.id);
    this.termina();
  }
  confirm_pausa() {

    if (!this.show_fine) {
      this.translate.get(['microj.VUOIMETTEREPAUSA', 'microj.METTIPAUSA', 'microj.ESCISENZASALVARE', 'microj.NOPAUSA', 'ANNULLA']).subscribe(v => {
        // console.log(this.mj);
        // console.log(this.all_microquest);
        let buttonsx = [];
        let testo = '';
        // if (parseInt(d.durataMassima) != 0 || parseInt(d.durataMinima) != 0) {
        // && this.ce_una_domanda_temporizzata == false
        // console.log(this.domande);
        // console.log(this.contatoredomande);
        if (this.mq.temporizzazione == null && (parseInt(this.domande[this.contatoredomande].durataMassima) == 0 && parseInt(this.domande[this.contatoredomande].durataMinima) == 0)) {
          testo = v['microj.VUOIMETTEREPAUSA'];
          buttonsx = [
            {
              text: v['microj.METTIPAUSA'],
              handler: () => {
                this.termina();
                // console.log('Disagree clicked');
              }
            },
            {
              text: v['microj.ESCISENZASALVARE'],
              handler: () => {
                this.cancella_e_termina();
                // console.log('Agree clicked');
              }
            },
            {
              text: v['ANNULLA'],
              handler: () => {
                // console.log('Agree clicked');
              }
            }
          ];
        }
        else {
          testo = v['microj.NOPAUSA'];
          let buttonsx = [
            {
              text: 'OK',
              handler: () => {
                // console.log('Agree clicked');
              }
            }
          ]
        }
        const confirm = this.alertCtrl.create({
          title: testo,
          buttons: buttonsx,
          cssClass: this.etheme.theme_selected
        });
        confirm.present();
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/msteps/msteps.ts